import { Typography, useMediaQuery, useTheme } from "@mui/material";

interface IProps {
    /**
     * The title to display on the page.
     */
    title: string;
}

export const PageTitle = ({ title }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Typography
            variant={isMobile ? "h5" : "h4"}
            color={"primary"}
            textTransform={"capitalize"}
            maxWidth={isMobile ? "100%" : 400}
            minWidth={100}
            sx={{
                wordWrap: "break-word",
            }}
        >
            {title}
        </Typography>
    );
};
